<template>
  <div>
    <div class="clear-both container mx-auto p-0" v-show="menuData">
      <!-- <Curves background="517185" foreground="fff" location="bottomRight" /> -->
      <footer class="py-4 md:py-8">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="items-center justify-around mx-auto">
            <div
              class="flex items-center mx-auto"
              v-if="menuData && menuData.social_media_links"
            >
              <div class="flex mx-auto items-center">
                <a
                  v-for="link in menuData.social_media_links"
                  :key="link.icon"
                  :href="link.url"
                  target="_blank"
                >
                  <SocialMediaIcon :icon="link.icon" />
                </a>
              </div>
            </div>

            <div class="flex items-center md:mx-auto md:mt-8">
              <div class="flex mx-auto items-center">
                <nav>
                  <ul
                    class="md:flex text-center"
                    v-if="menuData && menuData.navigation_links"
                  >
                    <li
                      v-for="item in menuData.navigation_links"
                      :key="item.text"
                    >
                      <a
                        :href="item.url"
                        class="px-3 py-2 md:mx-1 text-sm font-bold text-white"
                        v-text="item.text"
                      />
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="flex items-center mx-auto md:mt-4">
              <div class="flex mx-auto">
                <p
                  class="px-3 py-2 md:mx-1 text-xs font-light text-white"
                  v-text="menuData && menuData.copyright_text"
                />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type State from "~/domains/store/State";

const menuData = ref(undefined);
const store: Store<State> = useStore();

const { $config, $axios, $sg } = useNuxtApp();

async function getOctoberData(endpoint) {
  return await $axios
    .get($config.public.sgCmsApi + endpoint)
    .then((response) => response.data);
}

onMounted(async () => {
  const persistedState = store.state?.persistedState;
  const menuDataResponse = await $sg.getOctoberData("pages/footer");
  menuData.value = menuDataResponse;

  let infoData = null;

  if (persistedState.branchInfo || persistedState.branchCode) {
    infoData = persistedState.branchInfo?.BranchInfo?.InfoData;

    if (!infoData) {
      infoData = await $axios
        .get(
          $config.public.sgCmsApi +
            `branch/${persistedState.branchCode}/branchinfo`
        )
        .then((response) => response.data.BranchInfo.InfoData)
        .catch((error) => ({ error: error, response: error.response.data }));
    }
  }

  if (infoData) {
    const fbUrl = infoData.find((data) => data.FieldName === "Facebook URL");

    if (fbUrl?.FieldValue) {
      menuData.value.social_media_links.find((a) => a.icon === "facebook").url =
        fbUrl.FieldValue;
    }
  }
});
</script>


<style scoped>
footer {
  background-color: #517185;
}

li {
  margin-top: 1rem;
}

ul {
  margin-top: 2rem;
  margin-left: 0;
}

@media (min-width: 768px) {
  li {
    margin-top: 0;
  }
}
</style>
